import { render, staticRenderFns } from "./user_tab2.vue?vue&type=template&id=9045dd32&scoped=true"
import script from "./user_tab2.vue?vue&type=script&lang=js"
export * from "./user_tab2.vue?vue&type=script&lang=js"
import style0 from "./user_tab2.vue?vue&type=style&index=0&id=9045dd32&prod&scoped=true&lang=less"
import style1 from "./user_tab2.vue?vue&type=style&index=1&id=9045dd32&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9045dd32",
  null
  
)

export default component.exports